'use client';

import { useLanguage } from '@/context/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Reveal from '@/components/Reveal';
import BriefForm from '@/components/BriefForm';

export default function BriefPageClient() {
  const { t } = useLanguage();

  return (
    <>
      <Navbar />
      <main className="pt-24 pb-20 bg-dark-950 min-h-screen">
        <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="mb-10">
              <p className="text-sm font-semibold text-electric tracking-widest uppercase mb-4">
                {t('Création de site web', 'Website creation')}
              </p>
              <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
                {t('Créez votre présence en ligne', 'Build your online presence')}
              </h1>
              <p className="text-lg text-white/50 leading-relaxed max-w-2xl">
                {t(
                  'Décrivez votre activité et vos attentes. On conçoit votre site vitrine sur mesure et on revient vers vous sous 24h.',
                  'Describe your business and expectations. We design your custom website and get back to you within 24h.'
                )}
              </p>
            </div>
          </Reveal>

          <BriefForm />
        </section>
      </main>
      <Footer />
    </>
  );
}
